import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import {
  pluginKeys,
  toSlackStatusView,
  usePluginApiClient,
  type SlackStatusView,
} from '@/entities/plugin';

export function useSlackStatusQuery(
  enabled = true,
): UseQueryResult<SlackStatusView | null, Error> {
  const client = usePluginApiClient();

  return useQuery<SlackStatusView | null, Error>({
    queryKey: pluginKeys.slackStatus(),
    enabled,
    queryFn: async ({ signal }) => {
      const raw = await client.getSlackStatus(signal);
      return toSlackStatusView(raw);
    },
  });
}
